import { uploadFileToBase64String } from "../../../../../common/utils/utils";
import { NovosNegociosForm } from "../../../presentation/schemas/Novos_negocios_cadastro/novosNegociosCadastro";
import { IUpdateNovosNegociosUseCase } from "../../../presentation/useCases/update/update_novos_negocios_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateNovosNegociosUseCase
 */

export class UpdateNovosNegociosUseCase implements IUpdateNovosNegociosUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(form: NovosNegociosForm): Promise<void> {
    const computedArquivoNome = form.limparArquivo ? null : form.arquivo?.name;
    const computedArquivo = form.limparArquivo ? null : form.arquivo;

    await this.repository.updateNovosNegocios({
      idNovosNegocios: form.idNovosNegocios ?? undefined,
      idCliente: form.idCliente ?? undefined,
      idFuncionario: form.idFuncionario ?? undefined,
      dataSituacao: form.dataSituacao ?? undefined,
      telefone: form.telefone ?? undefined,
      nrNegocio: Number(form.nrNegocio) ?? undefined,
      titulo: form.titulo ?? undefined,
      idCentroCusto: form.idCentroCusto ?? undefined,
      nProposta: form.nProposta ?? undefined,
      nEdital: form.nEdital ?? undefined,
      possivelEscopo: form.possivelEscopo ?? undefined,
      viavelFinanc: form.viavelFinanc ?? undefined,
      possivelPrazos: form.possivelPrazos ?? undefined,
      possivelReqLegais: form.possivelReqLegais ?? undefined,
      comentarios: form.comentarios ?? undefined,
      situacaoProposta: form.situacaoProposta ?? undefined,
      statusParticipar: form.statusParticipar ?? undefined,
      outros: form.outros ?? undefined,
      observacao: form.observacao ?? undefined,
      dataCriacao: form.dataCriacao ?? undefined,
      data: form.data ?? undefined,
      cidade: form.cidade ?? undefined,
      dadosCliente: form.dadosCliente ?? undefined,

      nomeArquivo: computedArquivoNome ? computedArquivoNome : undefined,
      arquivo: computedArquivo ? await uploadFileToBase64String(computedArquivo) : undefined,
      limparArquivo: form.limparArquivo ?? false,

    });

  }
}
